import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import MainLayout from "../../shared/layouts/main.layout";
import { ROUTE_LOGIN } from "../../shared/routes/auth.routes";

import {
  ROUTES_OPEN,
  ROUTES_PROTECTED
} from "../../shared/routes/renderer.route";
import { RootState } from "../../shared/types/common";
import { setActiveRoute } from "../store/reducers/settings.slice";
import { ROUTE_DASHBOARD, ROUTE_MANAGE_PROJECT } from "../../shared/routes/private.routes";

function RouteGuard() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const routeIndex = ROUTES_PROTECTED.findIndex((route) => {
      let routeParam = route.route.split("/")[1];
      let currentPath = location.pathname.split("/")[1];
      return routeParam === currentPath;
    });
  
    if (routeIndex !== -1) {
      const { name, route: path } = ROUTES_PROTECTED[routeIndex];
      dispatch(setActiveRoute({ name, path })); // ✅ Only dispatch serializable values
    }
  }, [location, dispatch]);
  

  return accessToken ? (
    <React.Fragment>
      <Routes>
        {ROUTES_PROTECTED.map((route: any, index: number) => {
          return (
            <Route
              path={route.route}
              key={index}
              element={
                ['/print-receipt/:id', '/print-online-receipt/:id'].indexOf(route.route) === -1 ?
                  <MainLayout>{route.component}</MainLayout>
                  : <>{route.component}</>
              }
            />
          );
        })}
        {/* <Route path="*" element={<Navigate to={ROUTE_DASHBOARD} replace />} /> */}
        <Route path="*" element={<Navigate to={ROUTE_MANAGE_PROJECT} replace />} />
      </Routes>
    </React.Fragment>
  ) : (
    <Routes>
      {ROUTES_OPEN.map((route: any, index: number) => {
        return (
          <Route path={route.route} key={index} element={route.component} />
        );
      })}
      <Route path="*" element={<Navigate to={ROUTE_LOGIN} replace />} />
    </Routes>
  );
}

export default RouteGuard;
